<template>
  <div>
    <h1 class="titleColorSystem pb-4 text-center">Proyectos de investigacion</h1>
    <div class="sci-proy-content">
      <table class="sci-proy-table">
        <thead class="sci-proy-thead">
          <div class="sci-proy-buttons">
            <v-select
              v-model="proj"
              :items="projects"
              item-value="id"
              class="sci-prod-vselect"
              item-text="name"
              label="Proyectos de ciencia, tecnología e innovación"
              clearable=""
          ></v-select>  
          <v-select
            v-model="year"
            :items="years"
            item-value="fecha_termino"
            class="sci-prod-vselect"
            item-text="date"
            label="Indicar año"
            clearable=""
          ></v-select>
          <div class="sci-proy-busqueda">
            <div class="sci-proy-busqueda">
              <input v-model="search" type="text" placeholder="Buscar proyecto" autofocus><button class="sci-proy-lupa"></button>
            </div>
          </div>
          <span v-if="this.proj == 1 && this.search && this.year">
            <vue-excel-xlsx
              class="sci-proy-excel"
              :data="proyectosExcel.data"
              :columns="columns1"
              :filename="'ProyectosInvestigadores'"
              :sheetname="'proyectos de investigadores'"
            >
              Descargar resultados de proyectos de investigadores
            </vue-excel-xlsx>
          </span>
          <span v-if="this.proj == 2 && this.search && this.year"> 
            <vue-excel-xlsx
              class="sci-proy-excel"
              :data="proyectosApoyadosExcel.data"
              :columns="columns2"
              :filename="'Proyectos Apoyados COCyTED'"
              :sheetname="'apoyados COCyTED'"
            >
              Descargar resultados de proyectos apoyados por COCyTED
            </vue-excel-xlsx>
          </span>
          </div>
          <span v-if="this.proj == 1 && this.search && this.year" class="sci-proy-count">Hay {{this.proj == 1 ? proyCount : ''}} proyectos de investigadores que coinciden con el filtro</span>
          <span v-if="this.proj == 2 && this.search && this.year" class="sci-proy-count">Hay {{this.proj == 2 ? apoyadosCount : ''}} proyectos apoyados por cocyted que coinciden con el filtro</span>
          <tr v-if="this.proj == 1" class="sci-proy-tr1 text-center">
            <th class="sci-proy-tr1-ti">Titulo</th>
            <th class="sci-proy-tr1-ti">Objetivo</th>
            <th class="sci-proy-tr1-area">Area de conocimiento</th>
            <th class="sci-proy-tr1-tipo">Año</th>
            <th class="sci-proy-tr1-nom">Investigador</th>
            <th class="sci-proy-tr1-obj">Contactar</th>
          </tr>
          <tr v-else class="sci-proy-tr3 text-center">
            <th class="sci-proy-tr1-ti">Titulo</th>
            <th class="sci-proy-tr1-tipo">año</th>
            <th class="sci-proy-tr1-nom">convocatoria</th>
            <th class="sci-proy-tr1-nom">monto aprobado</th>
            <th class="sci-proy-tr1-nom">Organización proponente</th>
            <th class="sci-proy-tr1-nom">Investigador</th>
            <th class="sci-proy-tr1-obj">Contactar</th>
          </tr>
        </thead>
        <tbody class="sci-proy-tbody" v-if="this.proj == 1">
          <div>
            <tr v-for="(proyecto, index) in proyectos.data" :key="index" class="sci-proy-tr2">
              <td class="sci-proy-tbody-nom">{{ proyecto.titulo ? proyecto.titulo : "El titulo está nulo" }}</td>
              <td class="sci-proy-tbody-nom">{{ proyecto.objetivo ? proyecto.objetivo : "El objetivo está nulo" }}</td>
              <td class="sci-proy-tbody-area">{{ proyecto.area_conocimiento }}</td>
              <td class="sci-proy-tbody-tipo">{{ proyecto.fecha_termino ? `${proyecto.fecha_termino.substring(0,4)}` : "El año está nulo" }}</td>
              <td class="sci-proy-tbody-tipo">{{ proyecto.nombre_investigador ? proyecto.nombre_investigador : "No tiene el campo especificado" }}</td>
              <td style="text-align: center;" v-if="proyecto" @click="openMailModal(proyecto.id, proyecto)">
                <span class="material-icons" style="cursor:pointer;">
                  mail_outline
                </span>
              </td>
            </tr>
          </div>
        </tbody>
        <tbody class="sci-proy-tbody2" v-if="this.proj == 2">
          <div>
            <tr v-for="(proyecto, index) in proyectosApoyados.data" :key="index" class="sci-proy-tr4">
              <td class="sci-proy-tbody-nom">{{ proyecto.titulo ? proyecto.titulo : "El titulo está nulo" }}</td>
              <td class="sci-proy-tbody-tipo">{{ proyecto.year ? proyecto.year : "No tiene año" }}</td>
              <td class="sci-proy-tbody-tipo">{{ proyecto.convocatoria ? proyecto.convocatoria : "Este campo esta nulo" }}</td>
              <td class="sci-proy-tbody-tipo">{{ proyecto.monto_aprobado ? "$"+formatPrice(proyecto.monto_aprobado) : "El campo monto está nulo" }}</td>
              <td class="sci-proy-tbody-tipo">{{ proyecto.institucion ? proyecto.institucion : "Este campo está nulo" }}</td>
              <td class="sci-proy-tbody-tipo">{{ proyecto.responsable_tecnico ? proyecto.responsable_tecnico : "Este campo está nulo" }}</td>
              <td style="text-align: center;" v-if="proyecto" @click="openMailModal(proyecto.id, proyecto)">
                <span class="material-icons" style="cursor:pointer;">
                  mail_outline
                </span>
              </td>
            </tr>
          </div>
        </tbody>
        <tbody v-if="this.proj != 1 && this.proj != 2">
          <div class="sci-proy-noResults">Sin resultados</div>
        </tbody>
        <v-spacer></v-spacer>
        <div class="pagination justify-content-center">
          <pagination v-if="this.proj == 1 || this.search || this.year" :limit="vPaginator.limit" :data="this.proyectos" @pagination-change-page="getProyectos"></pagination>
          <pagination v-if="this.proj == 2 || this.search || this.year" :limit="vPaginator.limit" :data="this.proyectosApoyados" @pagination-change-page="getProyectosApoyados"></pagination>
        </div>
        <v-spacer></v-spacer>
        <investigador-email
          :show.sync="dialog"
          :investigador="currentInvestigadorName"
          :investigador-id="currentInvestigadorID"
        ></investigador-email>
      </table>
    </div>
  </div>
</template>

<script>
import InvestigadorEmail from './InvestigadorEmail';
import { mapState, mapMutations, mapActions } from "vuex";
import axios from "axios";
export default {
  components:{
    InvestigadorEmail
  },
  name: 'Proyectos',
  props: ["urlApi","configuracion"],
  data() {
    return {
      columns1: [
        {label: "Titulo", field: "titulo"},
        {label: "Objetivo", field: "objetivo"},
        {label: "Area de conocimiento", field: "area_conocimiento"},
        {label: "Año", field: "fecha_termino"},
        {label: "Investigador", field: "nombre_investigador"},
      ],
      columns2: [
        {label: "Titulo", field: "titulo"},
        {label: "Año", field: "year"},
        {label: "Convocatoria", field: "convocatoria"},
        {label: "Monto aprobado", field: "monto_aprobado"},
        {label: "Organizacion proponente", field: "institucion"},
        {label: "Investigador", field: "responsable_tecnico"},
      ],
      proj: [{id:1}, {id:2}],
      palabrasClave: [{name: "evalucion"}, {name: "arañas"}, {name: "chile"}],
      search: null,
      proyectos: {
        current_page: 1,
        data: []
      },
      proyectosApoyados: {
        current_page: 1,
        data: []
      },
      proyectosExcel: {},
      proyectosApoyadosExcel: {},
      years: [{id: 1, date: 2018}, {id: 2, date: 2019}, {id: 3, date: 2020},{id: 4, date: 2021},{id: 5, date: 2022},{id: 6, date: 2023}],
      year: [],
      vPaginator: {
        limit: 10
      },
      dialog: false,
      menu: false,
      CurrentElement: {},
      currentInvestigadorID: null,
      currentInvestigadorName: null
    };
  },
  watch:{
    proj: function(value){
      if (value == 1  && this.year){
        this.search = '';
        this.year = [];
        this.getProyectos();
      }
      else if(value == 2  && this.year){
        this.search = "";
        this.year = [];
        this.getProyectosApoyados();
      }
    },
    year: function(value){
      if(value == this.year && this.proj == 1 ){
        this.search = '';
        this.getProyectos();
      }
      else if(value && this.proj == 2 ){
        this.search = '';
        this.getProyectosApoyados();
      }
    },
    search: function(value){
      if(this.year && this.proj == 1 && value.length > 3 && value == this.search) {
        this.getProyectos();
        this.getProyectosExcel();
      }
      else if(this.year && this.proj == 2 && value.length > 3 && value == this.search){
        this.getProyectosApoyados();
        this.getProyectosApoyadosExcel();
      }
    },
  },
  methods: {
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    openMailModal: function(invID, name){
      this.dialog = true;
      this.currentInvestigadorID = invID;
      this.currentInvestigadorName = name;
    },
    getProyectos: function(page = 1){
      var url= process.env.VUE_APP_API_URL + `/api/proyectos-investigadores?page=${page}&query=${this.search}&secondQuery=${this.year ? this.year : ''}`;
      axios.get(url)
      .then(response => { this.proyectos = response.data})
      .catch(error => errorHandling(error));
    },
    getProyectosExcel: function(page = 1){
      var url= process.env.VUE_APP_API_URL + `/api/proyectos-investigadores?perPage=200&page=1&query=${this.search}&secondQuery=${this.year ? this.year : ''}`;
      axios.get(url)
      .then(response => { this.proyectosExcel = response.data})
      .catch(error => errorHandling(error));
    },
    getProyectosApoyados: function(page = 1){
      var url= process.env.VUE_APP_API_URL + `/api/proyectos-apoyados?page=${page}&query=${this.search}&secondQuery=${this.year ? this.year : ''}`;
      axios.get(url)
      .then(response => { this.proyectosApoyados = response.data})
      .catch(error => errorHandling(error));
    },
    getProyectosApoyadosExcel: function(page = 1){
      var url= process.env.VUE_APP_API_URL + `/api/proyectos-apoyados?perPage=200&page=1&query=${this.search}&secondQuery=${this.year ? this.year : ''}`;
      axios.get(url)
      .then(response => { this.proyectosApoyadosExcel = response.data})
      .catch(error => errorHandling(error));
    },
  },
  computed:{
    proyCount: function(){
      return this.proyectos.total;
    },
    apoyadosCount: function(){
      return this.proyectosApoyados.total;
    },
    projects (){
      if(this.configuracion != null){
        let items = [{id: 1, name: "Proyectos desarrollados por investigadores"}, {id: 2, name: "Proyectos apoyados por el " + this.configuracion.nombre_institucion }]
        return items;
      }
    }
  },
  created() {
    // this.getProyectos();
    // this.getProyectosApoyados();
    // this.limpiarCampos();
  },
};
</script>
<style>
.sci-proy-title {
  margin: 3% auto 0% auto;
  text-transform: uppercase;
  color: rgba(255, 196, 0, 0.9);
  font-weight: bold;
  font-size: 1.5em;
}
.sci-inv-dot {
  font-weight: bold;
  color: rgba(0, 152, 255, 0.9);
  margin-bottom: 4%;
}
.sci-inv-dot:before {
  content: "";
  display: inline-block;
  width: 90px;
  height: 1px;
  background: rgba(0, 0, 0, 0.5);
  margin-right: 1.2%;
  border-radius: 1px 1px;
}
.sci-inv-dot:after {
  content: "";
  display: inline-block;
  width: 90px;
  height: 1px;
  background: rgba(0, 0, 0, 0.5);
  margin-left: 1.2%;
  border-radius: 0 0 0 0;
}
.sci-proy-content {
  width: 86%;
  margin: 0 auto 10% auto;
}
.sci-proy-table {
  display: grid;
  grid-area: sci-proy-table;
  border-spacing: 0;
  margin: 0 auto;
  width: 100%;
  align-content: start;
  margin-bottom: 100px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 1px solid #aaa;
}
.sci-proy-thead {
  background: transparent;
  color: #000;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
}
.sci-proy-busqueda {
  width: 100%;
  grid-template-columns: 3fr 3fr 3fr 2fr;
  border-radius: 5px 5px 5px 5px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 5px 5px 5px 5px;
}
.sci-proy-busqueda{
		color: black;
		display: grid;
		justify-content: start;
		width: 100%;
		grid-template-columns: 1fr;
		position: relative;
    margin: 2% 0 0 2%;
	}
.sci-proy-busqueda input{
  background: #FFF;
  width: 65%;
  height: 25px;
  margin: 0 0 13px 0;
  border-radius: 0px 0 0 0px;
  border: none;
  padding: 0 15px;
  font-size: .8em;
  position: relative;
  background: gainsboro;
  padding: 15px;border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 1px solid #aaa;
}
.sci-proy-busqueda input:focus{
  outline: 0;
}
.sci-proy-busqueda input::placeholder{
  text-transform: uppercase;
}
.sci-proy-lupa{
  background: #0084FF;
  border: none;
  width: 35px;
  height: 32px;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  position: absolute;
  top: 0;
  left: calc(100% - 40%);
}
.sci-proy-lupa:before{
    display: inline-block;
    content: '';
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 2px solid #FFF;
    position: relative;
    left: -6px;
    top: -12px;
  }
  .sci-proy-lupa:after{
    content: '';
    width: 10px;
    height: 2px;
    display: inline-block;
    background: #FFF;
    transform: rotate(45deg);
    position: absolute;
    top: 18px;
    left: 17px;
  }
  .sci-proy-excel{
		font-weight: bold;
		color: rgb(117, 180, 239);
		font-size: 1.1rem;
		border: 1px solid #ccc;
		padding: .4rem;
		margin: 1rem 0 1rem 0;
		border-radius: 5px;
		display: grid;
	}
.sci-proy-buttons{
  display: grid;
  grid-template-columns:  1fr 1fr;
  margin: 1rem;
  grid-gap: 1rem;
}
.sci-proy-button{
  background: #0084FF;
  padding: 10px;
  color: white;
  border-radius: 9px;
  width: 64%;
  margin: auto;
}
.sci-aca-lupa:before{
  display: inline-block;
  content: '';
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid #FFF;
  position: relative;
  left: -6px;
  top: -12px;
}
.sci-aca-lupa:after{
  content: '';
  width: 10px;
  height: 2px;
  display: inline-block;
  background: #FFF;
  transform: rotate(45deg);
  position: absolute;
  top: 18px;
  left: 17px;
}
.sci-proy-count{
		color: #0D47A1;
		font-size: 1.03rem;
		font-weight: bold;
    display: grid;
		text-align: left;
		padding: 1rem 1rem 1rem 0;
	}
.v-label,
.v-select__selection--comma {
  color: #0d47a1 !important;
}
.v-select__selection--comma {
  color: #0d47a1;
}
.sci-proy-tr1 {
  display: grid;
  grid-template-columns: 2fr 2fr 2fr 1fr 2fr 1fr;
  text-transform: uppercase;
  font-weight: 100;
  margin-top: 2.5%;
  background-color: gainsboro;
  border-radius: 5px 5px 5px 5px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 5px 5px 5px 5px;
}
.sci-proy-noResults{
  text-align: center;
  margin: 2rem;
  text-transform: uppercase;
  font-weight: bold;
}
.sci-proy-tbody {
  /* border-left: 1px solid #000;
		border-right: 1px solid #000; */
  background: #fff;
  color: #000;
  text-align: left;
  padding: 15px;
}
.sci-proy-tr2 {
  display: grid;
  grid-template-columns: 2fr 2fr 2fr 1fr 2fr 1fr;
  text-transform: uppercase;
}
.sci-proy-tr2 :nth-child(4){
  text-align: left;
}
.sci-proy-tr4 {
  display: grid;
  grid-template-columns: 4fr 1fr 3fr 1fr 2fr 2fr 1fr;
  text-transform: uppercase;
  padding: 1rem 0.5rem;
  text-align: left;
}
.sci-proy-tr4 td{
  padding: 0 .5rem;
}
.sci-proy-tr4 :nth-child(2),.sci-proy-tr4 :nth-child(4){
  text-align: center;
}
.sci-proy-tr2 td {
  padding: 10px;
  /* border-bottom: 1px solid #000; */
}
.sci-proy-tr3{
  display: grid;
  grid-template-columns: 4fr 1fr 3fr 1fr 2fr 2fr 1fr;
  text-transform: uppercase;
  font-weight: 100;
  margin-top: 2.5%;
  background-color: gainsboro;
  border-radius: 5px 5px 5px 5px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 5px 5px 5px 5px;
}
.sci-proy-tbody-inf {
  margin: auto;
}
.sci-proy-tr1-fechas {
  /* background: red; */
  margin: auto 3px;
}
.sci-proy-tr1-fechaInicial {
  /* background: red; */
  width: 50%;
  text-align: center;
}
.sci-proy-tr1-fechaFinal {
  /* background: blue; */
  width: 50%;
  text-align: center;
}

@media only screen and (max-width: 1000px) and (min-width: 100px) {
  .sci-proy-content {
    width: 90%;
    grid-template-areas: "sci-proy-table";
    grid-template-columns: 1fr;
  }
  .sci-proy-table {
    width: 100%;
    margin: 2% auto;
  }
  .sci-proy-tr1-nom {
    min-width: 16%;
  }
  .sci-proy-tr1-ti {
    min-width: 16%;
  }
  .sci-proy-tr1-area {
    min-width: 16%;
  }
  .sci-proy-tr1-tipo {
    min-width: 16%;
  }
  .sci-proy-tr1-res {
    min-width: 16%;
  }
  .sci-proy-tr1-obj {
    min-width: 16%;
  }
  .sci-proy-tbody-nom {
    min-width: 16%;
  }
  .sci-proy-tbody-ti {
    min-width: 16%;
  }
  .sci-proy-tbody-area {
    min-width: 16%;
  }
  .sci-proy-tbody-tipo {
    min-width: 16%;
  }
  .sci-proy-tbody-res {
    min-width: 16%;
  }
  .sci-proy-tbody-obj {
    min-width: 16%;
  }
}
@media screen and (max-width: 850px) and (min-width: 50px) {
  .sci-proy-content {
    width: 97%;
  }
  .sci-proy-tr1 {
    font-size: 0.85rem;
  }
  .sci-proy-tbody-area {
    font-size: 0.8rem;
  }
  .sci-proy-tbody-obj {
    font-size: 0.8rem;
  }
}
@media screen and (max-width: 600px) and (min-width: 50px) {
  .sci-proy-content {
    width: 97%;
  }
  .sci-proy-tr1 {
    font-size: 0.7rem;
  }
  .sci-proy-tbody-nom {
    font-size: 0.7rem;
  }
  .sci-proy-tbody-ti {
    font-size: 0.7rem;
  }
  .sci-proy-tbody-area {
    font-size: 0.65rem;
  }
  .sci-proy-tbody-tipo {
    font-size: 0.7rem;
  }
  .sci-proy-tbody-res {
    font-size: 0.7rem;
  }
  .sci-proy-tbody-obj {
    font-size: 0.65rem;
  }
}
@media screen and (max-width: 450px) and (min-width: 50px) {
  .sci-proy-content {
    width: 97%;
  }
  .sci-proy-tr1 {
    font-size: 0.48rem;
  }
  .sci-proy-tbody-nom {
    font-size: 0.65rem;
  }
  .sci-proy-tbody-ti {
    font-size: 0.65rem;
  }
  .sci-proy-tbody-area {
    font-size: 0.54rem;
  }
  .sci-proy-tbody-tipo {
    font-size: 0.65rem;
  }
  .sci-proy-tbody-res {
    font-size: 0.65rem;
  }
  .sci-proy-tbody-obj {
    font-size: 0.57rem;
  }
}
.text-center{
  text-align: center;
}
</style>
